import { render } from "./Kids.vue?vue&type=template&id=496a4304&scoped=true"
import script from "./Kids.vue?vue&type=script&lang=js"
export * from "./Kids.vue?vue&type=script&lang=js"

import "./Kids.vue?vue&type=style&index=0&id=496a4304&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496a4304"]])

export default __exports__